module.exports = __webpack_public_path__ + "img/aston_martin.9cd4a899.jpg";